import { Category, CategoryResponse } from '../types/categories';

export const transformCategoryResponse = (response: CategoryResponse[]): Category[] => {
  return response.map(
    (categoryResponse): Category => ({
      name: categoryResponse.name,
      categoryId: categoryResponse.categoryid,
      slug: categoryResponse.slug,
      primaryImage: categoryResponse["primary-image"],
      parentCategorySlug: (categoryResponse["parent-category"] ?? [])[0]?.slug,
      higherLevelParentCategoriesSlugs: (categoryResponse["higher-level-parent-categories"] ?? []).map(
        (higherLevelParentCategory) => higherLevelParentCategory.slug,
      ),
      solutionGroup: (categoryResponse["solution-group"] ?? []).map((solutionGroup) => ({
        name: solutionGroup.name,
        slug: solutionGroup.slug,
      }))[0],
      popularityAcrossCategories: categoryResponse["popularity-across-categories"],
      popularityInCategory: categoryResponse["popularity-in-category"],
    }),
  );
};

export const sortCategoriesByPopularityAcrossCategory = (a: Category, b: Category) => {
  if (typeof a.popularityAcrossCategories !== 'number') return 1;
  if (typeof b.popularityAcrossCategories !== 'number') return -1;
  return b.popularityAcrossCategories - a.popularityAcrossCategories;
};

export const sortCategoriesByPopularityInCategory = (a: Category, b: Category) => {
  if (typeof a.popularityInCategory !== 'number') return 1;
  if (typeof b.popularityInCategory !== 'number') return -1;
  return b.popularityInCategory - a.popularityInCategory;
};

export const sortCategoriesByName = (a: Category, b: Category) => {
  return a.name.localeCompare(b.name);
};
